/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_All_Caught_UpInputs */

const en_confirm_all_caught_up = /** @type {(inputs: Confirm_All_Caught_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All caught up — no other lessons to confirm.`)
};

const he_confirm_all_caught_up = /** @type {(inputs: Confirm_All_Caught_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכל מעודכן — אין שיעורים נוספים לאישור.`)
};

/**
* | output |
* | --- |
* | "All caught up — no other lessons to confirm." |
*
* @param {Confirm_All_Caught_UpInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_all_caught_up = /** @type {((inputs?: Confirm_All_Caught_UpInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_All_Caught_UpInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_all_caught_up(inputs)
	return he_confirm_all_caught_up(inputs)
});